import CustomLayout from 'component/layout/custom_layout';
import React, { useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { ReactComponent as CopyIcon } from 'assets/svg/copyIcon.svg';
import { makeStyles } from '@material-ui/core';
import { copyToClipboard } from 'utils/share';
import SucessIcon from '@material-ui/icons/CheckCircleOutline';
import { Spinner } from 'react-bootstrap';
import themes from 'styles/themes';

const useStyles = makeStyles(() => ({
    unlistedBox: {
        color: themes.palette.primary.main,
        padding: 24,
    },
    label: {
        fontSize: '14px',
    },
    linkBox: {
        marginTop: 22,
        borderBottom: '1px solid',
        paddingBottom: 10,
        display: 'flex',
    },
    link: {
        fontSize: '16px',
        flex: 1,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    buttonPublishBox: {
        position: 'fixed',
        '@media (min-width: 1024px)': {
            position: 'absolute',
        },
        width: 'auto',
        left: 0,
        right: 0,
        zIndex: 100,
        bottom: 0,
        padding: 24,
        WebkitTransition: 'all .35s ease-in-out',
        transition: 'all .35s ease-in-out',
    },
    buttonPublish: {
        width: '100%',
        height: '48px',
        padding: '0',
        textAlign: 'center',
        color: themes.palette.common.white,
        fontSize: 12,
        fontWeight: 600,
        fontFamily: 'PoppinsRegular',
        background: themes.palette.primary.main,
        border: 'none',
        borderRadius: '29px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    copyMsg: {
        backgroundColor: themes.palette.common.white,
        fontFamily: 'PoppinsRegular',
        fontStyle: 'normal',
        textAlign: 'center',
        color: themes.palette.primary.main,
        padding: '10px',
    },
    noneCopyMsg: {
        visibility: 'hidden',
        padding: '10px',
    },
    successIcon: {
        color: themes.palette.primary.main,
        marginRight: 5,
    },
}));
const PublishToUnlisted = (props) => {
    const classes = useStyles();
    const [showElement, setShowElement] = useState(false);

    const handleClickCopyToClipboard = (text) => {
        return new Promise((resolve) => {
            copyToClipboard(text);
            setShowElement(true);
            setTimeout(() => {
                setShowElement(false);
                resolve('done');
            }, 1500);
        });
    };
    return (
        <CustomLayout
            title="Publish Unlisted"
            hideBottomNav={true}
            headerLeftBtn={
                <CloseIcon
                    style={{ color: themes.palette.primary.main }}
                    onClick={() => {
                        props.handleClose();
                    }}
                />
            }
        >
            <div className={classes.unlistedBox}>
                <div className={classes.label}>Users can access this style only via a link</div>
                <div className={classes.linkBox}>
                    <div className={classes.link}>{props.link}</div>
                    <CopyIcon onClick={() => handleClickCopyToClipboard(props.link)} />
                </div>
            </div>
            <div className={classes.buttonPublishBox}>
                <button onClick={props.onPublish} className={classes.buttonPublish}>
                    Publish{' '}
                    {props.isSubmitPublishLoading && (
                        <Spinner animation="border" style={{ marginLeft: 10, width: 18, height: 18 }} />
                    )}
                </button>
            </div>
            <div className={showElement ? classes.copyMsg : classes.noneCopyMsg}>
                <SucessIcon className={classes.successIcon} />
                Link copied to clipboard
            </div>
        </CustomLayout>
    );
};

export default PublishToUnlisted;
